import React from 'react';
import { createBrowserRouter } from "react-router-dom";
import Dashboard from "../01_Dashboard/Dashboard.jsx";
import ErrorPage from "./ErrorPage.jsx";
import AboutMe from "../02_AboutMe/AboutMe";
import Blog from "../03_Blog/Blog";
import Belize from "../03_Blog/Components/01_Belize";
import Mauritius from "../03_Blog/Components/02_Mauritius";
import Thailand from "../03_Blog/Components/04_Thailand";
import SriLanka from "../03_Blog/Components/05_SriLanka";
import Split from "../03_Blog/Components/03_Split";
import Zandvoort from "../03_Blog/Components/06_Zandvoort";
import Norwegen from "../03_Blog/Components/07_Norwegen";
import Schweden from "../03_Blog/Components/08_Schweden";
import Schottland from "../03_Blog/Components/09_Schottland";
import Thailand2025 from "../03_Blog/Components/10_Thailand";
import Schweden2026 from "../03_Blog/Components/11_Schweden";
import Korsika from "../03_Blog/Components/12_Korsika";



export const router = createBrowserRouter([
    {
        path: "/",
        element: <Dashboard/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/aboutme",
        element: <AboutMe/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/blog",
        element: <Blog/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/belize",
        element: <Belize/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/mauritius",
        element: <Mauritius/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/split",
        element: <Split/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/thailand",
        element: <Thailand/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/srilanka",
        element: <SriLanka/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/zandvoort",
        element: <Zandvoort/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/norwegen",
        element: <Norwegen/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/schweden",
        element: <Schweden/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/schottland",
        element: <Schottland/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/thailand2025",
        element: <Thailand2025/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/schweden2026",
        element: <Schweden2026/>,
        errorElement: <ErrorPage/>
    },
    {
        path: "/korsika",
        element: <Korsika/>,
        errorElement: <ErrorPage/>
    },
]);
